import { IPlanContent, IPlans } from '../../../models/plans/plans.model';
import { PlanActionType } from './actionTypes';
export const createPlan = (data: any) => {
    return {
        payload: data,
        type: PlanActionType.CREATE_PLAN
    };
};
export const getPlans = (data: any) => {
    return {
        payload: data,
        type: PlanActionType.GET_PLANS
    };
};
export const setPlans = (data: IPlans) => {
    return {
        payload: data,
        type: PlanActionType.SET_PLANS
    };
};
export const setCreatePlanError = (data: string) => {
    return {
        payload: data,
        type: PlanActionType.SET_CREATE_PLAN_ERROR
    };
};
export const setCreatePlanLoading = (data: any) => {
    return {
        payload: data,
        type: PlanActionType.SET_CREATE_PLAN_LOADING
    };
};

export const getPlanById = (data: any) => {
    return {
        payload: data,
        type: PlanActionType.GET_PLAN_BY_ID
    };
};
export const setPlanById = (data: IPlanContent) => {
    return {
        payload: data,
        type: PlanActionType.SET_PLAN_BY_ID
    };
};

export const updatePlan = (data: any) => {
    return {
        payload: data,
        type: PlanActionType.UPDATE_PLAN
    };
};

export const deletePlan = (data: any) => {
    return {
        payload: data,
        type: PlanActionType.DELETE_PLAN
    };
};
